(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["parma-header-lingua"] && !Shopify.designMode) return;
  try {
    (function () {
    function chiudi(eccetto) {
      document.querySelectorAll('details[data-p-lingua][open]').forEach(function (d) {
        if (d !== eccetto) d.removeAttribute('open');
      });
    }

    document.addEventListener('click', function (e) {
      chiudi(e.target.closest('details[data-p-lingua]'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var aperto = document.querySelector('details[data-p-lingua][open]');
      if (!aperto) return;
      aperto.removeAttribute('open');
      aperto.querySelector('summary').focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
